import { Table } from 'react-bootstrap';
import styled from 'styled-components';

export const TableWrapper = styled(Table)`
    & > thead > tr > th {
        background-color: #133366;
        color: white;
        border: 1px solid white;
    }
    
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;

interface IGridWrapperProps {
    height?: string
}

export const GridWrapper = styled.div<IGridWrapperProps>`
    height: ${p => p.height ? p.height : '65vh'};
    
    font-family: Roboto;

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row-selected > .ag-cell {
        background-color: yellow !important;
        color: black;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .center-list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
        //border-left: 1px solid white;
        border-right: 1px solid white;
        // border-bottom: 1px solid white;
    }

    .list-header-no-border {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
        //border-left: 1px solid white;
        //border-right: 1px solid white;
        // border-bottom: 1px solid white;
    }

    .list-header-left {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
        border-left: 1px solid white;
        border-right: 1px solid white;
        // border-bottom: 1px solid white;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
        //border-left: 1px solid white;
        border-right: 1px solid white;
        // border-bottom: 1px solid white;
    }

    .list-header-right {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        color: #fff;
        //border-left: 1px solid white;
        border-right: 1px solid white;
        // border-bottom: 1px solid white;
    }

    .center-list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 28px;
        border-color: #ccc;
        font-size: 12px;
        justify-content: center;
        display: flex;
    }

    .group-header {
        background-color: #133366;
        color: white;
    }

    .group-header-left {
        background-color: #133366;
        color: white;
        border-left: 1px solid white;
        border-right: 1px solid white;
        border-bottom: 1px solid white;
    }

    .group-header-right {
        background-color: #133366;
        color: white;
        // border-left: 1px solid white;
        border-right: 1px solid white;
        border-bottom: 1px solid white;
    }

    .group-header-left .ag-header-group-cell-label,
    .group-header-right .ag-header-group-cell-label {
        display: flex;
        justify-content: center;
    }

    .customHeaderLabel {
        text-align: center;
    }
`;